export const SET_COMPANY = "SET_COMPANY";
export const SET_COMPANY_CONSTRUCTOR = "SET_COMPANY_CONSTRUCTOR";
export const SET_COMPANY_SINGLE = "SET_COMPANY_SINGLE";
